import { UserAction } from "../actions";
// import { Alert } from "react-native"
import { Functions, ApiCaller, Variables } from "../../config";
import info from "../../components/info";
import { put, delay } from "redux-saga/effects";
import {
  CANCEL_SUBSCRIPTION,
  CHECK_ACCOUNT,
  CREATE_ACCOUNT,
  CREATE_LINK,
  DEACTIVE_USER,
  NOTTIFICATION,
  SUBSCRIPTION,
  UPDATE_PROFILE,
  USER,
} from "../../config/variables";
import AuthAction from "../actions/AuthAction";
import axios from "axios";

const userId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[2]
  ?.rmx_company_user?.id;

export default class userMiddleWarre {

  static *getUserMiddleWare(action) {
    const { id, params } = action;
    const qureyParams = new URLSearchParams(params).toString();

    const companyId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[1]
      ?.logistics_partner?.id;
    try {
      let res = yield ApiCaller.Get(
        `logistics_partners/${companyId}/users?${qureyParams}`,
        {
          "Content-Type": "application/json",
        }
      );

      if (res.status == 200) {
        yield put(
          UserAction.getUserSuccess(res.data.data, null, res.data.meta)
        );

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.getUserError());
      }
    } catch (e) {
      yield put(UserAction.getUserError());
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *createUserMiddleWare(action) {
    const { payload, cb, params } = action;

    const companyId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[1]
      ?.logistics_partner?.id;
    let formData = new FormData();
    for (const key in payload) {
      formData.append(key, payload[key]);
    }

    try {
      let res = yield ApiCaller.Post(
        `logistics_partners/${companyId}/users`,
        formData,
        {
          "Content-Type": "application/json",
        }
      );

      if (res.status == 201) {
        cb() && cb();
        yield put(UserAction.getUserSuccess(res.data.data, null));
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.createUserError());
      }
    } catch (e) {
      yield put(UserAction.createUserError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *getUserDetailMiddleWare(action) {
    const { cb } = action;

    const companyId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[1]
      ?.logistics_partner?.id;
    const userId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[2]
      ?.logistics_partner_user?.id;
    try {
      let res = yield ApiCaller.Get(
        `logistics_partners/${companyId}/users/${userId}`,
        {
          "Content-Type": "application/json",
        }
      );

      if (res.status == 200) {
        yield put(UserAction.getUserDetailSuccess(res.data.data.user));
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.getUserDetailError());
      }
    } catch (e) {
      yield put(UserAction.getUserDetailError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *getCompanyDetails(action) {
    const { userId, cb } = action;

    const companyId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[1]
      ?.logistics_partner?.id;
    try {
      let res = yield ApiCaller.Get(`logistics_partners/${companyId}`, {
        "Content-Type": "application/json",
      });

      if (res.status == 200) {
        yield put(UserAction.getCompanyDetailSuccess(res.data.data));
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.getCompanyDetailError());
      }
    } catch (e) {
      yield put(UserAction.getCompanyDetailError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *getLocationMiddleWare(action) {
    const { cb } = action;

    const companyId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[1]
      ?.logistics_partner?.id;
    try {
      let res = yield ApiCaller.Get(
        `logistics_partners/${companyId}/locations`,
        {
          "Content-Type": "application/json",
        }
      );

      if (res.status == 200) {
        yield put(UserAction.getLocationSuccess(res.data.data));
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.getLocationError());
      }
    } catch (e) {
      yield put(UserAction.getLocationError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }
  static *getCardsMiddleWare(action) {
    const { cb, params } = action;
    const qureyParams = new URLSearchParams(params).toString();

    const companyId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[1]
      ?.logistics_partner?.id;
    try {
      let res = yield ApiCaller.Get(
        `logistics_partners/${companyId}/stripe/cards?${qureyParams}`,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(UserAction.getCardsSuccess(res.data.data, res.data.meta));
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.getCardsError());
      }
    } catch (e) {
      yield put(UserAction.getCardsError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *createLocationMiddleWare(action) {
    const { payload, cb } = action;
    const companyId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[1]
      ?.logistics_partner?.id;
    const signComId = JSON.parse(localStorage.getItem("companyInfo"))?.id;
    try {
      let res = yield ApiCaller.Post(
        `logistics_partners/${signComId ? signComId : companyId}/locations`,
        { location: payload },
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 201) {
        console.log("responseData==>", res.data);
        yield put(UserAction.createLocationSuccess(res.data.data));
        cb() && cb();
        info("success", "Plant added successfully");
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.createLocationError());
      }
    } catch (e) {
      yield put(UserAction.createLocationError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *deleteLocationMiddleWare(action) {
    const { id, cb } = action;
    const companyId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[1]
      ?.logistics_partner?.id;
    try {
      let res = yield ApiCaller.Delete(
        `logistics_partners/${companyId}/locations/${id}`,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 204) {
        yield put(UserAction.deleteLocationSuccess(id));
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.deleteLocationError());
      }
    } catch (e) {
      yield put(UserAction.deleteLocationError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *updateLocationMiddleWare(action) {
    const { id, cb, body } = action;
    const companyId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[1]
      ?.logistics_partner?.id;
    try {
      let res = yield ApiCaller.Put(
        `logistics_partners/${companyId}/locations/${id}`,
        body,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(UserAction.UpdateLocationSuccess(id, res.data.data));
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.UpdateLocationError());
      }
    } catch (e) {
      yield put(UserAction.UpdateLocationError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *updateAssetsMiddleWare(action) {
    const { id, cb, body } = action;
    const companyId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[1]
      ?.logistics_partner?.id;
    const payload = {};
    if (body.cover || body.logo) {
      if (body.cover) {
        payload.cover = body.cover;
      }
      if (body.logo) {
        payload.logo = body.logo;
      }
    } else {
      payload.store_name = body.rmx_company_asset.store_name;
      payload.description = body.rmx_company_asset?.description;
    }
    let formData = new FormData();
    for (const key in payload) {
      formData.append(key, payload[key]);
    }

    try {
      let res = yield ApiCaller.Put(
        `logistics_partners/${companyId}/assets/${id}`,
        body.cover || body.logo ? formData : payload,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(UserAction.updateAssetsSuccess(id, res.data.data));
        if (body.cover) {
          info("success", "Cover Updated Successfully! ");
          cb() && cb();

          return;
        }
        if (body.logo) {
          info("success", "Logo Updated Successfully! ");
          cb() && cb();

          return;
        }
        if (!body.logo || !body.cover) {
          info("success", "Store Information Updated Successfully! ");
          cb() && cb();

          return;
        }
      } else {
        yield put(UserAction.updateAssetsError());
      }
    } catch (e) {
      yield put(UserAction.updateAssetsError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *updateBusinessInfoMiddleare(action) {
    // console.log("sdsdsad:", action);
    const { id, cb, body } = action;
    const { businessInfo, compId } = body
    console.log("action", businessInfo, compId);

    // const companyId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[1]
    //   ?.logistics_partner?.id;
    try {
      let res = yield ApiCaller.Put(`logistics_partners/${compId}`, businessInfo, {
        "Content-Type": "application/json",
      });
      if (res.status == 200) {
        localStorage.setItem("companyInfo", JSON.stringify(res.data.data));
        yield put(UserAction.updateBusinessInfoSuccess(id, res.data.data));
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.updateAssetsError());
      }
    } catch (e) {
      yield put(UserAction.updateAssetsError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *updateProfileInfoMiddleare(action) {

    const { id, cb, body, active } = action;

    const companyId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[1]
      ?.logistics_partner?.id;
    const uId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[2]
      ?.logistics_partner_user?.id;
    const url = active
      ? `logistics_partners/${companyId}/users/${id ? id : uId
      }/${active.toLowerCase()}`
      : `logistics_partners/${companyId}/users/${id ? id : uId}`;
    const payload = {};
    if (!body.image?.medium) {
      payload.image = body.image;
      delete body.id;
    }
    let formData = new FormData();
    for (const key in payload) {
      formData.append(key, payload[key]);
    }
    try {
      let res = yield ApiCaller.Put(
        url,
        !!(!body.image?.medium && !body.id) ? formData : body,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        if (cb) {
          cb();
        }
        info("success", "Contact information updated successfully!");
        if (active) {
          info("success", "Employee status change successfully!");
        }
        if (body?.image?.name) {
          info("success", "Image Updated Successfully!");
        }

        yield put(UserAction.updateProfileInfoSuccess(id, res.data.data.user));
        yield put(UserAction.getUserSuccess(res.data.data, id));
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.updateProfileInfoError());
      }
    } catch (e) {
      yield put(UserAction.updateProfileInfoError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *createAssetsMiddleare(action) {
    const { cb, body } = action;
    const companyId = JSON.parse(localStorage.getItem("companyInfo"))?.id;
    const payload = {
      ...body,
    };
    if (body.cover) {
      payload.cover = body.cover;
    }
    if (body.logo) {
      payload.logo = body.logo;
    }
    let formData = new FormData();
    for (const key in payload) {
      formData.append(key, payload[key]);
    }
    try {
      let res = yield ApiCaller.Post(
        `logistics_partners/${companyId}/assets`,
        body.cover || body.logo ? formData : body,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 201) {
        localStorage.setItem("assets", JSON.stringify(res.data.data));
        if (cb) {
          cb();
        }

        yield put(UserAction.createAssetsSuccess(res.data.data.user));
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.createAssetsError());
      }
    } catch (e) {
      yield put(UserAction.createAssetsError(e));
    }
  }
  static *deleteCardMiddleware(action) {
    const { id, cb, body, cardId } = action;

    const companyId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[1]
      ?.logistics_partner?.id;
    try {
      let res = yield ApiCaller.Delete(
        `logistics_partners/${companyId}/stripe/cards/${cardId}`,
        body,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(UserAction.getCardsReq());
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.updateAssetsError());
      }
    } catch (e) {
      yield put(UserAction.updateAssetsError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *setDefaultCardMiddleware(action) {
    const { id, cb, body, cardId } = action;
    const companyId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[1]
      ?.logistics_partner?.id;
    try {
      let res = yield ApiCaller.Put(
        `logistics_partners/${companyId}/stripe/cards/${cardId}/default`,
        {},
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(UserAction.getCardsReq());
        info("success", "Card set default successfully");
        cb() && cb();
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.updateAssetsError());
      }
    } catch (e) {
      yield put(UserAction.updateAssetsError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }
  static *verifyZipcodeMiddleware(action) {
    const { cb, payload } = action;

    try {
      let res = yield ApiCaller.Get(
        `verify_zipcode?zipcode=${payload.zipcode}`,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        yield put(UserAction.verify_zipcode_success());
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.verify_zipcode_error("Incorrect zip code."));
      }
    } catch (e) {
      yield put(UserAction.verify_zipcode_error("Incorrect zip code."));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *getAllDriversMiddleware(action) {
    const { id, params } = action;
    const qureyParams = new URLSearchParams(params).toString();

    const companyId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[1]
      ?.logistics_partner?.id;
    try {
      let res = yield ApiCaller.Get(
        `logistics_partners/${companyId}/drivers?${qureyParams}`,
        {
          "Content-Type": "application/json",
        }
      );

      if (res.status == 200) {
        yield put(
          UserAction.getAllDriversSuccess(res.data.data, res.data.meta)
        );

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.getAllDriversError());
      }
    } catch (e) {
      yield put(UserAction.getAllDriversError());
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *createDriverMiddleWare(action) {
    const { payload, cb, params } = action;

    const companyId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[1]
      ?.logistics_partner?.id;
    let formData = new FormData();
    for (const key in payload) {
      formData.append(key, payload[key]);
    }

    try {
      let res = yield ApiCaller.Post(
        `logistics_partners/${companyId}/drivers`,
        formData,
        {
          "Content-Type": "application/json",
        }
      );

      if (res.status == 201) {
        cb() && cb();
        yield put(UserAction.getAllDriversReq(res.data.data, null));
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.createUserError());
      }
    } catch (e) {
      yield put(UserAction.createUserError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }




  static *updateDriverMiddleware(action) {

    const { id, cb, body, active } = action;

    const companyId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[1]
      ?.logistics_partner?.id;
    const uId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[2]
      ?.logistics_partner_user?.id;
    const url = active
      ? `drivers/${id ? id : uId}/${active.toLowerCase()}`
      : `drivers/${id ? id : uId}`;
    const payload = {};
    if (!body.image?.medium) {
      payload.image = body.image;
      delete body.id;
    }
    let formData = new FormData();
    for (const key in payload) {
      formData.append(key, payload[key]);
    }
    try {
      let res = yield ApiCaller.Put(url, !!(!body.image?.medium && !body.id) ? formData : body,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        if (cb) {
          cb();
        }
        info("success", "Contact information updated successfully!");
        if (active) {
          info("success", "Employee status change successfully!");
        }
        if (body?.image?.name) {
          info("success", "Image Updated Successfully!");
        }

        // yield put(UserAction.updateProfileInfoSuccess(id, res.data.data.user));
        yield put(UserAction.getAllDriversReq());
        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.updateProfileInfoError());
      }
    } catch (e) {
      yield put(UserAction.updateProfileInfoError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *getAllPaversMiddleware(action) {
    const { id, params } = action;
    const qureyParams = new URLSearchParams(params).toString();

    const companyId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[1]
      ?.logistics_partner?.id;
      console.log("companyId", companyId);
      
    try {
      let res = yield ApiCaller.Get(
        // `logistics_partners/${companyId}/pavers?${qureyParams}`,
        `logistics_partners/${companyId}/pavers?${qureyParams}`,
        {
          "Content-Type": "application/json",
        }
      );
      console.log("res", res);      
      if (res.status == 200) {
        yield put(
          UserAction.getAllPaversSuccess(res.data.data, res.data.meta)
        );

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.getAllPaversError());
      }
    } catch (e) {
      yield put(UserAction.getAllPaversError());
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }

  static *createPaverMiddleWare(action) {
    const { payload, cb, params } = action;

    const companyId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[1]
      ?.logistics_partner?.id;
    let formData = new FormData();
    for (const key in payload) {
      formData.append(key, payload[key]);
    }
    formData.append("status", 2);

    try {
      let res = yield ApiCaller.Post(
        // `logistics_partners/${companyId}/pavers`,
        `logistics_partners/${companyId}/pavers`,
        formData,
        {
          "Content-Type": "application/json",
        }
      );

      if (res.status == 201) {
        cb() && cb();
        yield put(UserAction.getAllPaversReq(res.data.data, null));
      } else {
        yield put(UserAction.createUserError());
      }
    } catch (e) {
      yield put(UserAction.createUserError(e));
    }
  }

  static *updatePaverMiddleware(action) {

    const { id, cb, body, active } = action;
    // alert("body in updatepavermiddleware");
    // console.log("body in updatepavermiddleware", body);
    
    const companyId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[1]
      ?.logistics_partner?.id;
    const uId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[2]
      ?.logistics_partner_user?.id;
    const url = 
    // active
      // ? `pavers/${id ? id : uId}/${active.toLowerCase()}`
      // : `logistics_partners/${companyId}/pavers/${id}`;
      // : 
      // active
      // ? `logistics_partners/${companyId}/pavers/${id}/${active.toLowerCase()}`
      // : `logistics_partners/${companyId}/pavers/${id}`;
      // active
      // ? `logistics_partners/${2}/pavers/${id}/${active.toLowerCase()}`
      // : `logistics_partners/${2}/pavers/${id}`;
      active
      ? `pavers/${id}/${active.toLowerCase()}`
      : `logistics_partners/${companyId}/pavers/${id}`;
    // const payload = {};
    if (!body?.isImageUpdated) {
      delete body.image;
    }
    // let formData = new FormData();
    // for (const key in payload) {
    //   formData.append(key, payload[key]);
    // }
    // delete body.image;
    try {
      // let res = yield ApiCaller.Put(url, !!(!body.image?.medium && !body.id) ? formData : body,
      let res = yield ApiCaller.Put(url, body,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        if (cb) {
          cb();
        }
        info("success", "Contact information updated successfully!");
        if (active) {
          info("success", "Employee status change successfully!");
        }
        if (body?.image?.name) {
          info("success", "Image Updated Successfully!");
        }

        // yield put(UserAction.updateProfileInfoSuccess(id, res.data.data.user));
        yield put(UserAction.getAllPaversReq());
      } else {
        yield put(UserAction.updateProfileInfoError());
      }
    } catch (e) {
      yield put(UserAction.updateProfileInfoError(e));
    }
  }

  // static *createTokenMiddleware(action) {
  //   const { cb, payload, callback } = action;

  //   const params = new URLSearchParams();

  //   for (var key in payload) {
  //     params.append(`card[${key}]`, payload[key]);
  //   }

  //   // params.append("card[exp_month]", 12);
  //   // params.append("card[exp_year]", 22);
  //   // params.append("card[cvc]", 123);
  //   // params.append("card[number]", 4242424242424242);
  //   let res;
  //   try {
  //     res = yield axios.post("https://api.stripe.com/v1/tokens", params, {
  //       headers: {
  //         abc: "Bearer sk_test_NNyixqopBsFDglopAkCwvFrN",
  //       },
  //     });
  //     if (res.status == 200) {
  //       // console.log('responseee==>',res)
  //       yield put(UserAction.createCardReq({ token: res.data.id }, cb));
  //       // cb() && cb();
  //       // yield put(UserAction.getAddressReq(params));

  //       // Functions.showToast(res["data"]["data"]["message"])
  //       // navigate("SignUpVerify", { email })
  //     } else {
  //       callback();

  //       info("error", res.data.error.code);
  //       yield put(UserAction.createTokenError());
  //     }
  //   } catch (e) {
  //     yield put(UserAction.createTokenError(e));
  //     // Functions.showToast(res["data"]["error"]["message"], "danger")
  //     // info("%c{res}", "color: red", " => ", res);
  //   }
  // }


  static *createTokenMiddleware(action) {
    const { cb, payload, orderId } = action;

    const params = new URLSearchParams();

    for (var key in payload) {
      params.append(`card[${key}]`, payload[key]);
    }
    let res;
    try {
      res = yield axios.post("https://api.stripe.com/v1/tokens", params, {
        headers: {
          abc: "Bearer sk_test_NNyixqopBsFDglopAkCwvFrN",
        },
      });
      if (res.status == 200) {
        yield put(
          UserAction.createSubscriptionReq({ plan_id: 2, token: res.data.id })
        );
        yield put(UserAction.createTokenSucess());
        cb() && cb();
      } else {
        info("error", res.data.error.code);
        yield put(UserAction.createTokenError());
      }
    } catch (e) {
      yield put(UserAction.createTokenError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }


  static *createCardMiddleware(action) {
    const { cb, payload, orderId } = action;
    const companyId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[1]
      ?.logistics_partner?.id;

    let res;
    try {
      res = yield ApiCaller.Post(
        `logistics_partners/${companyId}/stripe/cards`,
        payload,
        {
          "Content-Type": "application/json",
        }
      );
      if (res.status == 200) {
        cb() && cb();
        // info("success", "Card Added Successfully!")
        // yield put(UserAction.getAddressReq(params));

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.createCardSuccess());
      }
    } catch (e) {
      yield put(UserAction.createCardError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }
  static *subscribitionReactivationReq(action) {
    const { payload, cb } = action;
    const companyId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[1]
      ?.logistics_partner?.id;

    try {
      let res = yield ApiCaller.Post(
        `logistics_partners/${companyId}/subscription/reactivation`,
        {}
      );
      if (res.status == 200) {
        yield put(UserAction.postSubscribitionReactivationSuccess());
        cb() && cb();
        info("success", "Subscription Reactivated Successfully!");
        yield put(UserAction.getCompantDetailReq());
      } else {
        yield put(UserAction.postSubscribitionReactivationError());
      }
    } catch (e) {
      yield put(UserAction.postSubscribitionReactivationError(e));
    }
  }
  static *subscribitionCancellationReq(action) {
    const { payload, cb } = action;
    const companyId = JSON.parse(localStorage.getItem("logistics_Auth"))?.[1]
      ?.logistics_partner?.id;
    try {
      let res = yield ApiCaller.Post(
        `logistics_partners/${companyId}/subscription/cancellation`,
        {}
      );
      if (res.status == 200) {
        yield put(UserAction.postSubscribitionCancellationSuccess());
        cb() && cb();
        info("success", "Subscription Cancelled Successfully");
        yield put(UserAction.getCompantDetailReq());
      } else {
        yield put(UserAction.postSubscribitionCancellationError());
      }
    } catch (e) {
      yield put(UserAction.postSubscribitionCancellationError(e));
    }
  }



  // ibad
  static *getSubscriptionPlanMiddleware(action) {
    const { cb, payload, orderId } = action;

    const params = new URLSearchParams();

    for (var key in payload) {
      params.append(`card[${key}]`, payload[key]);
    }

    // params.append("card[exp_month]", 12);
    // params.append("card[exp_year]", 22);
    // params.append("card[cvc]", 123);
    // params.append("card[number]", 4242424242424242);
    let res;
    try {
      res = yield ApiCaller.Get(`logistics_partners/subscription/plans`);
      if (res.status == 200) {
        yield put(UserAction.getSubscriptionPlanSucess(res.data.data));
        // yield put(UserAction.createSubscriptionReq())

        // cb() && cb();
        // yield put(UserAction.getAddressReq(params));

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        info("error", res.data.error.code);
        yield put(UserAction.createTokenError());
      }
    } catch (e) {
      yield put(UserAction.createTokenError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }





  static *createSubscriptionMiddleWare(action) {
    const { payload, cb, params } = action;

    const companyId = JSON.parse(localStorage.getItem("companyInfo"))?.id;
    const signComId = JSON.parse(localStorage.getItem("companyInfo"))?.[1]?.logistics_partner?.id;
    try {
      let res = yield ApiCaller.Post(
        `logistics_partners/${companyId ? companyId : signComId}/subscription`,
        payload,
        {
          "Content-Type": "application/json",
        }
      );

      if (res.status == 200) {
        localStorage.removeItem('companyInfo')
        localStorage.removeItem('assets')
        cb() && cb();
        yield put(UserAction.createSubscriptionSucess(res.data.data, null));

        // Functions.showToast(res["data"]["data"]["message"])
        // navigate("SignUpVerify", { email })
      } else {
        yield put(UserAction.createSubscriptionError());
      }
    } catch (e) {
      yield put(UserAction.createSubscriptionError(e));
      // Functions.showToast(res["data"]["error"]["message"], "danger")
      // info("%c{res}", "color: red", " => ", res);
    }
  }
}
